$(document).ready(function(){
    if($('#body form').length >= 1){
        var $input = $('.form-control')

        $input.on('focus click', function(){
            var $this = $(this),
                $label = $this.parent().siblings('label')

            $label.addClass('active')
        })

        $input.on('focusout', function(){
            var $this = $(this),
                $label = $this.parent().siblings('label')

            if(!$this.val()){
                $label.removeClass('active')
            }
        })

        $input.on('input autocomplete', function(){
            var $this = $(this),
                $label = $this.parent().siblings('label')

            if($this.val()) {
                $label.addClass('active')
            } else {
                console.log('input autocomplete')
                $label.removeClass('active')
            }
        })

        var wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener('wpcf7submit', function( event ) {
            console.log('testing')

            $input.each(function(){
                var $this = $(this),
                    $label = $this.parent().siblings('label')

                if($this.val()) {
                    $label.addClass('active')
                }
            })
        }, false );
    }

})